import React, { useState } from 'react';

import { CloseOutlined, CaretDownOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import styles from './index.module.css';

export const TagsList = ({ info, handleDeleteTag, isFieldDisabled }) => {
  const [countiesVisible, setCountiesVisible] = useState(false);
  const [citiesVisible, setCitiesVisible] = useState(false);

  const hasCities = info?.cities?.length > 0;
  const collapseCounties = info?.counties?.length > 10;
  const collapseCities = info?.cities?.length > 10;

  return (
    <div className={styles.tagsList}>
      <span className={styles.stateTitle}>
        {info?.counties?.length ? (
          <span className={styles.stateLabel}>
            <span>{`${info.state} (${info?.counties?.length})`}</span>
            {collapseCounties && (
              <>
                <span
                  className={classnames({
                    [styles.showCountiesButton]: true,
                    [styles.hideCountiesButton]: countiesVisible,
                  })}
                  onClick={() => setCountiesVisible(!countiesVisible)}>
                  <span>Show counties</span>
                  <CaretDownOutlined className={styles.showCountiesArrow} />
                </span>
                {!isFieldDisabled && (
                  <span
                    className={classnames({
                      [styles.showCountiesButton]: true,
                      [styles.hideCountiesButton]: countiesVisible,
                    })}
                    onClick={handleDeleteTag({ state: info?.state, deleteState: true })}>
                    <span> Clear all</span>
                    <CloseOutlined className={styles.clearAllCounties} />
                  </span>
                )}
              </>
            )}
          </span>
        ) : null}
      </span>

      <div
        data-testid='taglist'
        className={classnames({
          [styles.countiesLabels]: true,
          [styles.hideTagsList]: collapseCounties,
          [styles.visibleTagsList]: countiesVisible,
        })}>
        {info.counties.map((county) => (
          <span className={styles.tag} key={uuidv4()}>
            <span>{county}</span>
            {!isFieldDisabled && (
              <CloseOutlined
                className={styles.closeIcon}
                onClick={handleDeleteTag({ state: info.state, county, deleteState: info?.counties?.length <= 1 })}
              />
            )}
          </span>
        ))}
      </div>

      {hasCities && (
        <>
          <span className={styles.citiesTitle}>
            <span className={styles.stateLabel}>
              <span>{`Cities (${info.cities.length})`}</span>
              {collapseCities && (
                <span
                  className={classnames({
                    [styles.showCountiesButton]: true,
                    [styles.hideCountiesButton]: citiesVisible,
                  })}
                  onClick={() => setCitiesVisible(!citiesVisible)}>
                  <span>Show cities</span>
                  <CaretDownOutlined className={styles.showCountiesArrow} />
                </span>
              )}
            </span>
          </span>

          <div
            data-testid='cities-taglist'
            className={classnames({
              [styles.citiesLabels]: true,
              [styles.hideTagsList]: collapseCities && !citiesVisible,
              [styles.visibleCitiesList]: !collapseCities || citiesVisible,
            })}>
            {info.cities.map((city) => (
              <span className={styles.tag} key={uuidv4()}>
                <span>{city}</span>
                {!isFieldDisabled && (
                  <CloseOutlined
                    className={styles.closeIcon}
                    onClick={handleDeleteTag({ state: info.state, city })}
                  />
                )}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
